import { keyframes } from '@emotion/core'
import styled from '@themes/theme'

const messageShadowAni = keyframes`
  0%, 70%, 100% {
    transform: skew(0);
  }
  30% {
    transform: skew(-10deg);
  }
`
const messageHeadAni = keyframes`
  0%, 70%, 100% {
    transform: skewX(0deg);
    height: 30px;
  }
  30% {
    transform: skewX(3deg);
    height: 27px;
  }
`
const messageDecoAni = keyframes`
  0%, 70%, 100% {
    transform: skewX(0deg);
    height: 36px;
  }
  30% {
    transform: skewX(3deg);
    height: 32px;
  }
`
export const MessageAlertWrapper = styled.div`
  position: fixed;
  bottom: 76px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  flex-flow: column;
  align-items: center;
  width: auto;
  height: auto;
  &::before {
    content: '';
    position: absolute;
    bottom: -76px;
    left: 50%;
    transform: translateX(-50%);
    width: 100vw;
    height: 320px;
    background: linear-gradient(to top, rgba(0,0,0,.8), rgba(0,0,0,.7) 20%, rgba(0,0,0,0))
  }
  .message-alert-btn {
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 183px;
    background: none;
    .bubble-message {
      position: relative;
      display:flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 38px;
      margin-bottom: 12px;
      border-radius: 30px;
      color: ${props => props.theme.color.modalTxt};
      background: ${props => props.theme.color.themeTxt};
      box-shadow: 3px 5px 10px rgba(0, 0, 0, .3);
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: -18px;
        left: 50%;
        transform: translateX(-50%);
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        border-top: 10px solid ${props => props.theme.color.themeTxt};
        border-bottom: 10px solid transparent;
      }
    }
    .message-alert-character {
      position: relative;
      width: auto;
      height: 112px;
      transform: translate3d(1px, 0, 0);
    }
    .message-ball {
      position: relative;
      display:flex;
      justify-content: center;
      align-items: center;
      width: 110px;
      height: 110px;
      margin-top: -30px;
      background: ${props => props.theme.color.yellow};
      border-radius: 50%;
      .message-alert-character-hands {
        position: absolute;
        top: -4px;
        left: 50%;
        transform: translate3d(-48%, 0, 0);
        width: 60%;
        height: auto;
      }
      .message-ico {
        position: relative;
        width: 65px;
        height: 47px;
        .message-body {
          width: inherit;
          height: auto;
          transform: translate3d(0, 0, 0);
        }
        .message-shadow {
          position: absolute;
          top: 0;
          left: 0;
          width: inherit;
          height: auto;
          animation: ${messageShadowAni} 1.8s infinite;
          transform-origin: top;
        }
        .message-head {
          position: absolute;
          top: 0;
          left: 0;
          width: inherit;
          animation: ${messageHeadAni} 1.8s infinite;
          transform-origin: top;
        }
      }
      .badge-style {
        top: 22px;
        right: 11px;
        .am-badge-text {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 21px;
          height: 21px;
          font-size: ${props => props.theme.font.large};
        }
      }
    }
    // 메시지를 열었을때
    &.open {
      .message-ball {
        .message-ico {
          .message-shadow {
            display: none;
          }
          .message-head {
            animation: none;
            transform: rotate(180deg) translate3d(0, 0, 0);
          }
        }
      }
    }
  }
  // 메시지 미리보기 - 시즌 연출
  &.season-effect {
    .message-ball {
      background: ${props => props.theme.color.TP};
      .message-ball-bg {
        position: absolute;
        top: -2px;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        width: 110px;
        height: auto;
      }
      .message-deco {
        width: inherit;
        position: absolute;
        top: 0;
        left: 0;
        animation: ${messageDecoAni} 1.8s infinite;
        transform-origin: top;
      }
    }
  }
`
